// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"230":"55249864","278":"74210cee","350":"b2a28101"}[chunkId] + ".css";
};